import { render, staticRenderFns } from "./ProductSelectorDialog.vue?vue&type=template&id=0b2ae78f&scoped=true"
import script from "./ProductSelectorDialog.vue?vue&type=script&lang=js"
export * from "./ProductSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectorDialog.vue?vue&type=style&index=0&id=0b2ae78f&prod&scoped=true&lang=css"
import style1 from "./ProductSelectorDialog.vue?vue&type=style&index=1&id=0b2ae78f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ae78f",
  null
  
)

export default component.exports